export { default, type EcosystemSectionRawProps } from './EcosystemSection';
export type { EcosystemItem } from './ecosystem-data';
